import React from 'react'

import orderStatusIndex from 'data/order-status-index'

const OrderStatus = (props) => {
	let status = false;
	let statusText = false;

	let statusObject = orderStatusIndex[props.status.toString()];
	status = statusObject.status;
	statusText = statusObject.text;

	// if(props.status === 5) {
	// 	status = 'success';
	// 	statusText = 'Tamamlandı';
	// }
	// else if(props.status === -1) {
	// 	status = 'canceled';
	// 	statusText = 'İptal Edildi';
	// }
	// else if(props.status === 4) {
	// 	status = 'ongoing';
	// 	statusText = 'Ödeme Yapılıyor';
	// }
	// else {
	// 	status = 'open';
	// 	statusText = 'Açık';
	// }

	if(status) {
	    return (
			<span className={'order-status ' + (props.label ? 'label big ' : '') + status}>
				{!props.label && <i className="status-icon"></i>}<span className="status-text">{statusText}</span>
			</span>
	    )
	}
	else {
		return false;
	}
};

OrderStatus.defaultProps = {
    label: false,
    price: 0,
}

export default OrderStatus